import React from 'react';
import { Button } from '../../shared/_form';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm, destroy, change } from 'redux-form/immutable';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { informPremiumFollowers } from '../../../actions/currentManagerActions';

const FORM_NAME = 'massEmailMessage';

const MassEmailMessage = ({ sendMessage, formValues = Immutable.Map(), clearForm, formChange }) => {
  function onSubmit(e) {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    const form = formValues || Immutable.Map();

    sendMessage(form.toJS());
    clearForm();
  }

  function validate() {
    const information = formValues.get('information');

    if (!information) {
      formChange('hasError', true);
      return false;
    }
    formChange('hasError', false);
    return true;
  }

  function renderError() {
    const hasError = formValues.get('hasError');

    if (hasError) {
      return <span className='modal__warning'><i className='fa fa-exclamation-circle' /> Can not be empty</span>;
    }
    // eslint-disable-next-line no-undefined
    return undefined;
  }

  return (
    <div className='form__submit'>
      <Field className='form__field form__field--textarea'
        component='textarea'
        name='information'
        type='text' />
      <div>
        {renderError()}
      </div>
      <Button className='form__button form__button--green' onClick={ onSubmit } type='button'>Send</Button>
    </div>
  );
};

MassEmailMessage.propTypes = {
  clearForm: PropTypes.func.isRequired,
  formChange: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map),
  sendMessage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(FORM_NAME)(state),
  initialValues: {
    hasError: false
  }
});

const mapDispatchToProps = (dispatch) => ({
  sendMessage: (form) => dispatch(informPremiumFollowers((form))),
  formChange: (param, value) => dispatch(change(FORM_NAME, param, value)),
  clearForm: () => dispatch(destroy(FORM_NAME))
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(
  {
    destroyOnUnmount: false,
    form: FORM_NAME
  }
)(MassEmailMessage));



// WEBPACK FOOTER //
// ./app/components/managers/profile/MassEmailMessage.jsx